import React from 'react'
import RefundsTable from './RefundsTable';

const RefundsData = () => {
    return (
        <RefundsTable />
    )
}

export default RefundsData;
